// Models
import { NavigationLayoutList } from "#models/navigation";

export function getNavigationList(): NavigationLayoutList {
    return [
        {
            icon: "home",
            link: "/",
            text: "Home",
        },
        {
            icon: "menu",
            link: "/gds",
            text: "GDS",
        },
        {
            icon: "menu",
            link: "/ptc",
            text: "PTC",
        },
        {
            icon: "menu",
            link: "/corporate-ids",
            text: "Corporate IDs",
        },
        {
            icon: "menu",
            link: "/consolidators",
            text: "Consolidators",
        },
        {
            icon: "lock",
            title: "Administration",
            text: "Administration",
            submenu: true,
            defaultOpened: false,
            children: [
                {
                    can: "userView",
                    link: "/users",
                    text: "Users",
                },
                {
                    can: "roleView",
                    link: "/roles",
                    text: "Roles",
                },
                {
                    can: "permissionView",
                    link: "/permissions",
                    text: "Permissions",
                },
                {
                    can: "configView",
                    link: "/config",
                    text: "Configs",
                },
            ],
        },
    ];
}
